import {
  FaGraduationCap,
  FaPercent,
  FaWallet,
  FaClock,
} from "react-icons/fa";
import { CMS_PRIMARY } from "../commissionsConstants";

export { CMS_PRIMARY };

export const DETAIL_CARD_CLASS =
  "overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm";

export const DETAIL_SECTION_LABEL_CLASS =
  "text-xs font-semibold uppercase tracking-wide text-gray-500";

export const DETAIL_TABLE_HEAD_CLASS =
  "border-b border-gray-200 bg-[#F8FAFC] text-[clamp(9px,0.72vw,10px)] font-semibold uppercase tracking-wide text-gray-500";

export const DETAIL_TABLE_CELL_CLASS =
  "px-[clamp(0.45rem,1.1vw,0.75rem)] py-[clamp(0.35rem,0.85vw,0.625rem)] text-[clamp(10px,0.82vw,12px)] text-gray-700";

export const DETAIL_TABLE_SCROLL_CLASS =
  "overflow-x-auto [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden";

export const DETAIL_TABLE_MIN_CLASS = "w-full min-w-[min(100%,32rem)] border-collapse sm:min-w-[36rem]";

export const DETAIL_KPI_CARDS = [
  {
    key: "courseTuitionFee",
    sublabelKey: "courseTuitionFeeSublabel",
    label: "Course Tuition Fee",
    color: "#007BFF",
    iconBg: "rgba(0, 123, 255, 0.1)",
    Icon: FaGraduationCap,
    isCurrency: true,
  },
  {
    key: "providerCommissionOnshore",
    sublabelKey: "providerCommissionSublabel",
    label: "Provider Commission %",
    color: "#22c55e",
    iconBg: "rgba(34, 197, 94, 0.1)",
    Icon: FaPercent,
    isPercent: true,
  },
  {
    key: "expectedCommission",
    sublabelKey: "expectedCommissionSublabel",
    label: "Our Expected Commission",
    color: "#8b5cf6",
    iconBg: "rgba(139, 92, 246, 0.1)",
    Icon: FaWallet,
    isCurrency: true,
  },
  {
    key: "outstandingCommission",
    sublabelKey: "outstandingCommissionSublabel",
    label: "Outstanding Commission",
    color: "#f97316",
    iconBg: "rgba(249, 115, 22, 0.1)",
    Icon: FaClock,
    isCurrency: true,
  },
];

export const INSTALLMENT_STATUS_CLASS = {
  Paid: "bg-green-50 text-green-700 border border-green-200",
  Pending: "bg-amber-50 text-amber-700 border border-amber-200",
  Overdue: "bg-red-50 text-red-700 border border-red-200",
};

export const PAYMENT_TYPE_CLASS = {
  Commission: "bg-blue-50 text-blue-700 border border-blue-200",
  GST: "bg-gray-100 text-gray-700 border border-gray-200",
  Bonus: "bg-purple-50 text-purple-700 border border-purple-200",
};

export function formatCurrency(amount, currency = "AUD") {
  const num = Number(amount);
  const safe = Number.isFinite(num) ? num : 0;
  const symbol = currency === "AUD" ? "$" : currency;
  const formatted = safe.toLocaleString("en-AU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol} ${formatted}`;
}

export function formatPercent(value, decimals = 2) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0.00%";
  return `${num.toFixed(decimals)}%`;
}

export function getInitials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function formatAppBadge(appId, createdAt) {
  const id = String(appId ?? "").padStart(5, "0");
  const year = createdAt
    ? new Date(createdAt).getFullYear()
    : new Date().getFullYear();
  return `APP-${year}-${id}`;
}

export function formatDisplayDateTime(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  if (Number.isNaN(d.getTime())) return dateStr;
  const datePart = d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  const timePart = d.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return `${datePart}, ${timePart}`;
}

export function formatClientId(studentId) {
  return `CL-${String(studentId ?? "").padStart(6, "0")}`;
}

export function resolveIntakeLabel(intakeId, intakes = []) {
  if (!intakeId) return "—";
  const match = intakes.find(
    (i) =>
      String(i.id) === String(intakeId) ||
      String(i.intake_id) === String(intakeId),
  );
  return match?.title || match?.intake_title || `Intake #${intakeId}`;
}
